export default __webpack_public_path__ + "static/media/ans_4.35328cee.png";